export default "__VITE_ASSET__amEvwa5h__"